export default __webpack_public_path__ + "dumpert-logo-d98663.svg";